import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import DCDtlsView from "./DCDtlsView";
import DCHeaderView from "./DCHeaderView";
import DCRelatedView from "./DCRelatedView";
import UseFetchData from "../../../hooks/UseFetchData";
import { PinDropSharp } from "@material-ui/icons";


const DCMasterView = () => {
  const classes = useStyles();
  const [DCMainData, setDCMainData] = useState([]);
  const [DCDtlsData, setDCDtlsData] = useState([]);
  const [DCNoteData, setDCNoteData] = useState([]);
  const [DCAttachData, setDCAttachData] = useState([]);
  const [DCImageData, setDCImageData] = useState([]);
  const [DCActivityData, setDCActivityData] = useState([]);
  const location = useLocation();
  const [AccountID, setAccountID] = useState('');
  const [AccountName, setAccountName] = useState('');
  const [responseViewDtls, fetchViewDtls] = UseFetchData();
  // const [responseProductDtls, fetchProductDtls] = UseFetchData();


  const getViewDtlsData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("DeliveryChallanID", location.state.DeliveryChallanID);
    fetchViewDtls("DeliveryChallan/View", bodyFormData);
  }

  useEffect(() => {
    debugger;
    if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
      setDCMainData(responseViewDtls.Main);
      setAccountID(responseViewDtls.Main[0].AccountID);
      setAccountName(responseViewDtls.Main[0].AccountName);
    }
    if (responseViewDtls.DeliveryChallanDtls !== undefined && responseViewDtls.DeliveryChallanDtls.length > 0) {
      setDCDtlsData(responseViewDtls.DeliveryChallanDtls);
    }
    if (responseViewDtls.DeliveryChallanActivity !== undefined && responseViewDtls.DeliveryChallanActivity.length > 0) {
      setDCActivityData(responseViewDtls.DeliveryChallanActivity);
    }
    if (responseViewDtls.DeliveryChallanNotes !== undefined && responseViewDtls.DeliveryChallanNotes.length > 0) {
      setDCNoteData(responseViewDtls.DeliveryChallanNotes);
    }
    if (responseViewDtls.DeliveryChallanAttachments !== undefined && responseViewDtls.DeliveryChallanAttachments.length > 0) {
      setDCAttachData(responseViewDtls.DeliveryChallanAttachments);
    }
    if (responseViewDtls.DeliveryChallanImage !== undefined && responseViewDtls.DeliveryChallanImage.length > 0) {
      setDCImageData(responseViewDtls.DeliveryChallanImage);
    }
  }, [responseViewDtls]);

  useEffect(() => {
    getViewDtlsData();
    // getProductDtlsData();
  }, [])


  return (
    <Paper>
      <DCHeaderView
        DeliveryChallanID={location.state.DeliveryChallanID}
        DCMainData={DCMainData}
        PopulateData={getViewDtlsData}
      />
      <Grid container direction="row" className={classes.container}>
        <Grid sm={8} xs={12}>
          <Paper elevation={3} style={{ height: '100%' }}>
            <DCDtlsView
              DeliveryChallanID={location.state.DeliveryChallanID}
              DCMainData={DCMainData}
              DCDtlsData={DCDtlsData}
              PopulateData={getViewDtlsData}
            // PopulatesData={getProductDtlsData}
            />
          </Paper>
        </Grid>
        <Grid sm={4} xs={12}>
          <Paper elevation={3} >
            <h2 style={{ textDecoration: 'underline', textDecorationColor: '#0096FF', textDecorationThickness: 5, paddingLeft: 10 }}>RELATED</h2>
            <DCRelatedView
              DeliveryChallanID={location.state.DeliveryChallanID}
              DCMainData={DCMainData}
              DCNoteData={DCNoteData}
              DCAttachData={DCAttachData}
              DCImageData={DCImageData}
              DCActivityData={DCActivityData}
              PopulateData={getViewDtlsData}
            />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 7,
  },
}));

export default DCMasterView;
